import { render, staticRenderFns } from "./About.vue?vue&type=template&id=2d316dac&scoped=true"
import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=2d316dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d316dac",
  null
  
)

export default component.exports